import { motion } from "framer-motion";
import { Twitter, Instagram, Youtube, Mail } from "lucide-react";

const SOCIALS = [
  { icon: Twitter, label: "Twitter" },
  { icon: Instagram, label: "Instagram" },
  { icon: Youtube, label: "YouTube" },
  { icon: Mail, label: "Email" },
];

export default function Footer({ onAbout, onFAQ, onContact }) {
  const LINKS = {
    Company: [
      { label: "About Fanible", action: onAbout },
      { label: "Careers", action: null },
      { label: "Press Kit", action: null },
      { label: "Blog", action: null },
    ],
    Legal: [
      { label: "Privacy Policy", action: null, href: "/privacy" },
      { label: "Terms of Service", action: null, href: "/terms" },
      { label: "Delete Account", action: null, href: "/delete-account" },
      { label: "Cookie Policy", action: null },
    ],
    Support: [
      { label: "FAQs", action: onFAQ },
      { label: "Help Center", action: null },
      { label: "Get in Touch", action: onContact },
      { label: "Community Guidelines", action: null },
    ],
  };

  return (
    <footer data-testid="footer" className="bg-[#0B0D12] border-t border-white/5 pt-20 pb-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          {/* Top */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
            {/* Brand */}
            <div className="lg:col-span-2">
              <motion.a
                href="#"
                data-testid="footer-logo"
                className="flex items-center gap-2.5 mb-4"
                whileHover={{ opacity: 0.85 }}
                transition={{ duration: 0.2 }}
              >
                <div className="w-8 h-8 flex-shrink-0">
                  <img src="/fanible-icon.png" alt="Fanible" className="w-full h-full object-cover rounded-xl" style={{ mixBlendMode: "screen" }} />
                </div>
                <span className="font-outfit font-black text-2xl tracking-tighter text-white uppercase">Fanible</span>
              </motion.a>
              <p className="text-[#A1A1AA] text-sm leading-relaxed mb-6 max-w-xs font-inter">
                The ultimate social platform for sports and esports fans. Connect, compete, and celebrate the games you love.
              </p>
              {/* Social Icons */}
              <div className="flex gap-3">
                {SOCIALS.map(({ icon: Icon, label }) => (
                  <a
                    key={label}
                    href="#"
                    aria-label={label}
                    data-testid={`footer-social-${label.toLowerCase()}`}
                    className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#A1A1AA] hover:text-[#3B9EFF] hover:border-[#3B9EFF]/30 transition-all duration-300"
                  >
                    <Icon size={15} />
                  </a>
                ))}
              </div>
            </div>

            {/* Links */}
            {Object.entries(LINKS).map(([group, items]) => (
              <div key={group}>
                <h4 className="font-outfit font-bold text-white text-sm uppercase tracking-wider mb-5">{group}</h4>
                <ul className="space-y-3">
                  {items.map((item) => (
                    <li key={item.label}>
                      {item.action ? (
                        <button
                          onClick={item.action}
                          data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-[#A1A1AA] text-sm hover:text-[#3B9EFF] transition-colors duration-100 font-inter text-left"
                        >
                          {item.label}
                        </button>
                      ) : (
                        <a
                          href={item.href || "#"}
                          data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-[#A1A1AA] text-sm hover:text-white transition-colors duration-100 font-inter"
                        >
                          {item.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8" />

          {/* Bottom */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#A1A1AA] text-sm font-inter text-center md:text-left">
              &copy; 2026 Fanible Private Limited. All Rights Reserved.
            </p>
            <p className="text-center font-outfit font-bold text-sm text-[#3B9EFF] uppercase tracking-widest">
              Fanible &mdash; Where Fans Become the Game
            </p>
            <a
              href="#download"
              data-testid="footer-download-btn"
              className="text-sm font-bold text-black bg-[#3B9EFF] rounded-full px-5 py-2 hover:bg-white transition-colors duration-300 uppercase tracking-wider"
            >
              Download App
            </a>
          </div>
        </div>
      </footer>
  );
}
